export const getFridayDateByYearAndWeek = (year, week) => {
    if (typeof year !== 'number' || typeof week !== 'number' || week < 1 || week > 53) {
      return 'Invalid year or week';
    }
  
    const firstDayOfYear = new Date(year, 0, 1);
    const dayOfWeek = firstDayOfYear.getDay();
    const daysToFirstMonday = (dayOfWeek === 0 ? 1 : 8) - dayOfWeek;  
    const firstMonday = new Date(year, 0, 1 + daysToFirstMonday);
    const fridayOfWeek = new Date(firstMonday);
    fridayOfWeek.setDate(firstMonday.getDate() + (week - 1) * 7 + 4);
  
    return fridayOfWeek.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
